import React, { createContext, useContext, useEffect, useMemo, useReducer } from 'react';

import ls from 'local-storage';

import useNwBreakPoints from '@hooks/Layout/UseNwBreakPoints';

const LayoutContext = createContext(null);

const LayoutDispatchContext = createContext(null);

export const LAYOUT_CONTEXT_DATA_EMPTY = {
    showCollapsibleSidebar: false,
    hasCollapsibleSidebar: false,
    isMobile: false,
    isCalendarMobile: false,
    breakpoints: 0,
    headerHeight: 0,
    initialHeaderHeight: 0,
    forceCloseAllDrawers: 0,
};

export function LayoutProvider({ children }) {
    const breakpoints = useNwBreakPoints();

    const shouldHaveCollapsibleSidebar = useMemo(() => {
        if (breakpoints < 4) {
            //&& dataContext.scope === 'booking'
            return true;
        }
        return false;
    }, [breakpoints]);

    const initialShowCollapsibleSidebar = useMemo(() => {
        // if (!shouldHaveCollapsibleSidebar) {
        //     return false;
        // }
        // const savedState = ls.get(`nw_config_layout_sidebar_collapsed`);
        // return savedState === true;
        return false;
    }, [shouldHaveCollapsibleSidebar]); //dataContext.itemType, dataContext.scope

    const initialHeaderHeight = useMemo(() => {
        return breakpoints === 1 ? 104 : 60;
    }, [breakpoints]);

    const layoutContextData = useMemo(() => {
        return {
            showCollapsibleSidebar: initialShowCollapsibleSidebar,
            hasCollapsibleSidebar: shouldHaveCollapsibleSidebar,
            isMobile: breakpoints === 1,
            isCalendarMobile: breakpoints < 3,
            breakpoints: breakpoints,
            headerHeight: initialHeaderHeight,
            initialHeaderHeight: initialHeaderHeight,
            forceCloseAllDrawers: 0,
        };
    }, [initialShowCollapsibleSidebar, shouldHaveCollapsibleSidebar, breakpoints]);

    const [data, dispatch] = useReducer(layoutReducer, layoutContextData);

    // useEffect che monitora i cambiamenti dei breakpoints per la gestione della sidebar
    useEffect(() => {
        const currentHasCollapsibleSidebar = data.hasCollapsibleSidebar;

        // Se la sidebar non dovrebbe più essere collassabile ma lo è attualmente
        if (!shouldHaveCollapsibleSidebar && currentHasCollapsibleSidebar) {
            // Chiudi la sidebar se è aperta
            if (data.showCollapsibleSidebar) {
                dispatch({ type: 'ToggleSidebar' });
            }
        }
    }, [
        breakpoints,
        shouldHaveCollapsibleSidebar,
        data.hasCollapsibleSidebar,
        data.showCollapsibleSidebar,
        data.headerHeight,
    ]);

    // useEffect che aggiorna sempre i valori dei breakpoints quando cambiano
    useEffect(() => {
        // Aggiorna sempre i valori dei breakpoints quando cambiano
        dispatch({
            type: 'UpdateLayoutBreakpoints',
            hasCollapsibleSidebar: shouldHaveCollapsibleSidebar,
            isMobile: breakpoints === 1,
            isCalendarMobile: breakpoints < 3,
            breakpoints: breakpoints,
            headerHeight: initialHeaderHeight,
        });
    }, [breakpoints, shouldHaveCollapsibleSidebar, initialHeaderHeight]);

    return (
        <LayoutContext.Provider value={data}>
            <LayoutDispatchContext.Provider value={dispatch}>{children}</LayoutDispatchContext.Provider>
        </LayoutContext.Provider>
    );
}

export function useLayoutContext() {
    return useContext(LayoutContext);
}

export function useLayoutContextDispatch() {
    return useContext(LayoutDispatchContext);
}

export function useCloseAllDrawers() {
    const dispatch = useLayoutContextDispatch();
    return () => dispatch({ type: 'CloseAllDrawers' });
}

export function useResetForceCloseAllDrawers() {
    const dispatch = useLayoutContextDispatch();
    return () => dispatch({ type: 'ResetForceCloseAllDrawers' });
}

// const persistsLayout = async (value) => {
//     ls.set("nw_config_layout", value)
// }

const layoutReducer = (state, action) => {
    const draft = { ...state };
    switch (action.type) {
        case 'ToggleSidebar':
            const newShowCollapsibleSidebar = !state.showCollapsibleSidebar;
            ls.set(`nw_config_layout_sidebar_collapsed`, newShowCollapsibleSidebar);
            return {
                ...state,
                showCollapsibleSidebar: newShowCollapsibleSidebar,
            };
        case 'UpdateLayoutBreakpoints':
            return {
                ...state,
                hasCollapsibleSidebar: action.hasCollapsibleSidebar,
                isMobile: action.isMobile,
                isCalendarMobile: action.isCalendarMobile,
                breakpoints: action.breakpoints,
                headerHeight: action.headerHeight,
            };
        case 'CloseAllDrawers':
            return {
                ...state,
                forceCloseAllDrawers: state.forceCloseAllDrawers + 1,
            };
        case 'ResetForceCloseAllDrawers':
            return {
                ...state,
                forceCloseAllDrawers: 0,
            };
        default:
        //do nothing
    }
};
